module.exports = __webpack_public_path__ + "img/91.2072eeb8.jpg";